// Logika listy zgód marketingowych wydzielona z widoku: stan filtrów, wołanie
// API i eksport XLSX. Testy jednostkowe (vitest) nie montują komponentów —
// vitest.config.mjs celowo nie ładuje pluginu Vue — więc wszystko, co ma być
// pokryte testami, mieszka tutaj, a CustomerConsentList.vue dokłada już tylko
// szablon, kolumny tabeli i tłumaczenia.
import axios from 'axios'
import moment from 'moment'
import { Const } from '../config'

export const ORDER_TYPE_REQUEST = 'REQUEST_ORDER'
export const ORDER_TYPE_PAID = 'PAID_ORDER'

// W tabeli pokazujemy przetłumaczoną etykietę, nie surowy enum z API.
const ORDER_TYPE_LABEL_KEYS = {
    REQUEST_ORDER: 'forms.orderTypeRequest',
    PAID_ORDER: 'forms.orderTypePaid'
}

// Wpisywanie w pole szukania nie może wysyłać żądania po każdym znaku.
export const SEARCH_DEBOUNCE_MS = 300

const FILTER_NAMES = ['dateFrom', 'dateTo', 'orderType', 'search']

export function emptyFilters() {
    return {
        dateFrom: '',
        dateTo: '',
        orderType: '',
        search: ''
    }
}

// API rozpoznaje brak parametru jako "bez filtra" — pusty string byłby dla
// niego wartością do dopasowania (albo, przy datach, tekstem do sparsowania),
// więc puste filtry pomijamy zamiast wysyłać je jako "".
export function buildConsentParams(filters) {
    const source = filters || {}
    const params = {}
    FILTER_NAMES.forEach(name => {
        const value = source[name]
        if (value === null || value === undefined) {
            return
        }
        const trimmed = String(value).trim()
        if (trimmed !== '') {
            params[name] = trimmed
        }
    })
    return params
}

// Nieznany (np. dodany później w API) typ pokazujemy w surowej postaci —
// lepsze niż pusta komórka.
export function orderTypeLabel(orderType, translate) {
    const key = ORDER_TYPE_LABEL_KEYS[orderType]
    return key ? translate(key) : (orderType || '')
}

export function exportFileName(date) {
    return 'zgody-marketingowe-' + moment(date).format('YYYY-MM-DD') + '.xlsx'
}

export function debounce(callback, delay) {
    let timer = null
    return function () {
        const args = arguments
        if (timer !== null) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            timer = null
            callback.apply(this, args)
        }, delay)
    }
}

// Przeglądarka nie pozwala zapisać pobranej zawartości inaczej niż przez
// kliknięcie w <a download>. Link musi być w dokumencie (starsze Firefoksy
// ignorują kliknięcie w element spoza drzewa), a obiektowy URL zwalniamy od
// razu po kliknięciu, żeby blob nie został w pamięci karty.
function saveBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

export default {
    data() {
        return {
            pageNr: 1,
            allPages: "",
            items: [],
            exporting: false,
            filters: emptyFilters()
        }
    },
    created() {
        // Debounce per instancja — wspólny timer gubiłby wpisywanie, gdyby
        // widok został zamontowany dwa razy.
        this.debouncedSearch = debounce(this.applyFilters, SEARCH_DEBOUNCE_MS)
    },
    mounted() {
        this.refreshPage()
    },
    methods: {
        openDetails(item) {
            this.$router.push('/order-request/' + item.id)
        },
        handlePageChange(value) {
            this.pageNr = value
            this.refreshPage()
        },
        // Zmiana filtra wraca na pierwszą stronę: po zawężeniu wyników bieżący
        // numer strony często już nie istnieje i lista wyszłaby pusta.
        applyFilters() {
            this.pageNr = 1
            this.refreshPage()
        },
        onSearchInput() {
            this.debouncedSearch()
        },
        clearFilters() {
            this.filters = emptyFilters()
            this.applyFilters()
        },
        refreshPage() {
            if (this.pageNr == null || this.pageNr === "") {
                this.pageNr = 1
            }
            return axios.get(Const.API_HOST + '/admin/customers/consents/' + this.pageNr, {
                params: buildConsentParams(this.filters)
            }).then(body => {
                this.items = body.data.customers
                this.pageNr = body.data.pageNr
                this.allPages = body.data.allPages
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error)
            })
        },
        exportConsents() {
            this.exporting = true
            const params = buildConsentParams(this.filters)
            // Eksport służy do wysyłki mailingu, więc powtórzone adresy
            // (ten sam klient, kilka zamówień) mają dać jeden wiersz.
            params.uniqueByEmail = true
            return axios.get(Const.API_HOST + '/admin/customers/consents/export', {
                params: params,
                responseType: 'blob'
            }).then(response => {
                saveBlob(response.data, exportFileName())
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error)
            }).finally(() => {
                this.exporting = false
            })
        }
    }
}
